import axios from "axios";
import { apiURL } from "../config/default";
import { BRAND_SUCCESS, BRAND_FAIL } from "./types";

export const retreiveBySingleBrand = (id) => async (dispatch) => {
  const _config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const res = await axios.get(`${apiURL}get-single-brand/${id}`, _config);

    return res;
  } catch (err) {
    console.log(err);
    // const errors = err.response.data.error;
    dispatch({
      type: BRAND_FAIL,
    });
  }
};
export const retreiveBrandBySlug = (slug, page) => async (dispatch) => {
  const _config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  console.log(slug);
  try {
    const res = await axios.get(
      `${apiURL}get-brand-info/${slug}?page=${page}`,
      _config
    );

    return res;
  } catch (err) {
    console.log(err);
    // const errors = err.response.data.error;
    dispatch({
      type: BRAND_FAIL,
    });
  }
};
